<template>
    <div class="ActionPanel">
        <header>
            <h1 class="title font-size-big">{{ title }}</h1>
            <slot name="actions"></slot>
        </header>
        <div class="fields">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ActionPanel',
        props: {
            title: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/globals.scss";

    .ActionPanel {
        header {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
                margin: 0;
                color: white;
            }
        }
    }
</style>
